import React from 'react'
import '../styles/AboutUs.styles.css'
import about1 from '../assets/about1.jpg'
import about2 from '../assets/about2.jpg'
import about3 from '../assets/about3.jpg'
import about4 from '../assets/about4.jpg'
import { useOnScreen } from "../hooks/useOnScreen";

export default function AboutUs() {
  const [ref, isVisible] = useOnScreen({ threshold: 0.5 });
  return (
    <section className='about' id='nosotros'>
      <div className='ab-container'>
        <div className='ab-infoContainer'>
          <div className='divtxtAbout'>
            <div className='divExperiencia'>
              <div className='divAnio'>
                <div className='experiencia'>
                  <div className='experiencia2'>
                    <p>
                      +10
                    </p>
                    <p className='txtExp'>
                      años de experiencia
                    </p>
                  </div>
                </div>
              </div>
              <div className='divConocenos'>
                <p className='txtConocenos'>
                  Conócenos
                </p>
                <p className='txtEquipo'>
                  Nuestro equipo de profesionales altamente calificados y comprometidos trabaja de la mano de nuestros clientes para convertir sus ideas en realidad
                </p>
              </div>
              <div className='divEsf'>
                <p>
                  Nos esforzamos por superar las expectativas en términos de calidad, innovación y atención al detalle
                </p>
              </div>
            </div>
          </div>
          <div className='ab-dataContainer'>
            <div className='containerImgs'>
              <div className="ab-card">
                <div className='ab-icon'>
                  <div ref={ref} className={`divIcon ${isVisible?"is-visible1":""}`} >
                    <img src={about1} alt="ROSMO"/>
                  </div>
                </div>
              </div>
              <div className="ab-card">
                <div className='ab-icon'>
                  <div ref={ref} className={`divIcon ${isVisible?"is-visible2":""}`} >
                    <img src={about2} alt="ROSMO"/> 
                  </div>
                </div>
                <div>
                </div>
              </div>
              <div className="ab-card">
                <div className='ab-icon'>
                  <div ref={ref} className={`divIcon ${isVisible?"is-visible3":""}`} >
                    <img src={about3} alt="ROSMO"/> 
                  </div>
                </div>
              </div>
              <div className="ab-card">
                <div className='ab-icon'>
                  <div ref={ref} className={`divIcon ${isVisible?"is-visible4":""}`} >
                    <img src={about4} alt="ROSMO"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
